/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcDtcFilesV1FileState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_DTC_FILES_V1_FILE_STATE_ENTITY_NAME = 'exc.dtc.files.v1.File';
export const excDtcFilesV1FileStateEntity = new schema.Entity<ExcDtcFilesV1FileState>(EXC_DTC_FILES_V1_FILE_STATE_ENTITY_NAME, {}, { idAttribute: 'fileId' });

